import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetSharedPublicPostQuery } from '@/api/client';
import { LivestreamViewerScreen } from './LivestreamViewerScreen';

export default function LivestreamViewerPage(): React.ReactElement {
  const { shareId } = useParams<{ shareId: string }>();

  const {
    data: post,
    isLoading,
    error,
  } = useGetSharedPublicPostQuery(shareId || '', {
    skip: !shareId,
  });

  if (!shareId) {
    return (
      <div style={styles.errorContainer}>
        <h1 style={styles.title}>Invalid Livestream Link</h1>
        <p style={styles.text}>The livestream link appears to be invalid.</p>
        <a href="/download" style={styles.link}>Download the Hereabout App</a>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.loadingSpinner}>Connecting to livestream...</div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div style={styles.errorContainer}>
        <h1 style={styles.title}>Livestream Not Found</h1>
        <p style={styles.text}>This livestream may have ended or is no longer available.</p>
        <a href="/download" style={styles.link}>Download the Hereabout App</a>
      </div>
    );
  }

  if (!post.livestream_id) {
    return (
      <div style={styles.errorContainer}>
        <h1 style={styles.title}>Not a Livestream</h1>
        <p style={styles.text}>This link does not point to a livestream.</p>
        <a href="/download" style={styles.link}>Download the Hereabout App</a>
      </div>
    );
  }

  return (
    <LivestreamViewerScreen
      livestreamId={post.livestream_id}
      chatChannelId={post.chat_channel_id}
      title={post.title}
      username={post.username}
    />
  );
}

const styles: Record<string, React.CSSProperties> = {
  errorContainer: {
    minHeight: 'calc(var(--vh, 1vh) * 100)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    textAlign: 'center',
    backgroundColor: '#000',
  },
  title: {
    color: '#fff',
    fontSize: '24px',
    marginBottom: '12px',
  },
  text: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '16px',
    marginBottom: '20px',
  },
  link: {
    color: '#4a7bb7',
    fontSize: '16px',
    textDecoration: 'none',
  },
  loadingContainer: {
    minHeight: 'calc(var(--vh, 1vh) * 100)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#000',
  },
  loadingSpinner: {
    fontSize: '16px',
    color: '#fff',
  },
};
